export function loginDestination(user = {}) {
  const acessos = Array.isArray(user.acessos_lzv2) ? user.acessos_lzv2 : [];
  const hasAccess = (acesso) => acessos.indexOf(acesso) !== -1;
  const lzv2 = user.lzv2 || {};

  if ((user.chatAcesso || user.visualizarChat) && hasAccess("chats")) {
    return "/chat";
  }
  if (!user.operador && lzv2.upload && lzv2.respostas && hasAccess("relatorio_chats")) {
    return "/home";
  }
  if (hasAccess("campanhas")) return "/campanhas";
  if (hasAccess("validacao")) return "/temzap";
  if (hasAccess("chats")) return "/chat";
  return "/user";
}
